import { memo, useEffect, useState } from 'react';
import { CompactPicker } from 'react-color';

import { Card, Flex, Form, Input, InputNumber, Select } from 'antd';

import equal from 'fast-deep-equal';

import { FORM_FIELD_TYPE } from '../../../constants/common';
import { FARM_CREATE_FIELDS } from '../../../constants/farm';

import countries from '../../../countries.json';

const { TextArea } = Input;

function FarmCreateForm({ address, color, formRef, onChange, handleColorChange, setSubmittable }) {
  const [form] = Form.useForm();

  const [currentColor, setCurrentColor] = useState();
  const [initialFormValues, setInitialFormValues] = useState({});

  if (formRef) formRef.current = form;

  const values = Form.useWatch([], form);

  useEffect(() => {
    const initial = form.getFieldsValue(true);
    setInitialFormValues(initial);
  }, []);

  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [values]);

  useEffect(() => {
    if (color) setCurrentColor(color);
  }, [color]);

  useEffect(() => {
    if (address) {
      prepareFormValues();
    }
  }, [address]);

  function changeCurrentColor({ hex }) {
    setCurrentColor(hex);
    handleColorChange(hex);
  }

  function prepareFormValues() {
    return {
      holding_numbers: '0',
      house_number: address.house_number,
      postal_code: address.postal_code,
      street: address.street
    };
  }

  function handleChange() {
    const current = form.getFieldsValue();
    const isSame = equal(current, initialFormValues);

    onChange?.(!isSame);
  }

  return (
    <Card title="Farm Details" className="mb-2">
      <Form
        autoComplete="off"
        className="antd-form"
        name="farm-edit"
        form={form}
        initialValues={prepareFormValues()}
        labelCol={{ span: 6 }}
        requiredMark={true}
        onValuesChange={handleChange}>
        <Flex vertical={true} gap="small">
          {FARM_CREATE_FIELDS?.map(field => {
            return (
              <Form.Item
                labelWrap
                key={field.id}
                label={field.name}
                name={field.id}
                colon={false}
                labelAlign="left"
                rules={field.rules}>
                {field.type === FORM_FIELD_TYPE.SELECT ? (
                  <Select
                    className="mb-2"
                    name={field.id}
                    options={countries.map(x => ({ value: x, label: x }))}
                    showSearch={true}
                  />
                ) : field.type === FORM_FIELD_TYPE.TEXTAREA ? (
                  <TextArea className="textarea" name={field.id} />
                ) : field.type === FORM_FIELD_TYPE.NUMBER ? (
                  <InputNumber changeOnWheel className="w-full" min={0} name={field.id} />
                ) : (
                  <Input name={field.id} />
                )}
              </Form.Item>
            );
          })}

          <Form.Item label="Farm Color" labelAlign="left" name="color" colon={false}>
            <CompactPicker name="colour" color={currentColor} onChange={changeCurrentColor} />
          </Form.Item>
        </Flex>
      </Form>
    </Card>
  );
}

export default memo(FarmCreateForm);
